// eslint-disable-next-line import/prefer-default-export
export const lsRecommendedServiceItemIconStatusConstants = {
  cancelled: {
    icon: {
      name: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Cancelled on',
      endDatePath: 'status_set_at',
    },
  },

  // a customer should never see 'new' status
  new: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Review and approve your quote by',
      endDatePath: 'expires_at',
    },
  },

  ready: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Review and approve your quote by',
      endDatePath: 'expires_at',
    },
  },

  rejected: {
    icon: {
      name: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'You turned the quote down on',
      endDatePath: 'status_set_at',
    },
  },

  expired: {
    icon: {
      name: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Your quote expired on',
      endDatePath: 'status_set_at',
    },
  },

  approved: {
    icon: {
      name: 'checkmark',
      color: 'primary',
    },
    status: {
      text: 'You approved the quote on',
      endDatePath: 'status_set_at',
    },
  },
};
